import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=61fd0731&scoped=true"
import script from "./AccountDetail.vue?vue&type=script&lang=js"
export * from "./AccountDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountDetail.vue?vue&type=style&index=0&id=61fd0731&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd0731",
  null
  
)

export default component.exports